import { Container, dispatcher, ingenuity, Linear, SpineBase } from "@quest/base-core";
import { BackgroundController, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { gameConstants } from "../Constants/gameConstants";
import { IEvent } from "@quest/adapter-interface";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { eventDispatchers } from "../Constants/EventDispatchers";

/**
 * BackgroundControllerGame class manages the background elements and visuals
 * within the game, providing functionality for dynamic updates, transitions,
 * and interactions related to the game's background.
 *
 * This class serves as a controller to handle background-related logic,
 * enhancing the overall gaming experience by seamlessly integrating and
 * controlling background elements in response to game events.
 */
export class BackgroundControllerGame extends BackgroundController {
  private bonusgameBgSpine: SpineBase;
  private bonusgameBgPortraitSpine: SpineBase;
  private bonusGameBGContainer: Container;
  private bonusgameBgSpineContainer: Container;

  protected initializeElements(): void {
    super.initializeElements();
    this.bonusGameBGContainer = this.view.getContainerByID("bonusGameBgContainer");
    this.freegameBgSpine = this.view.getSpineById("freegame_idle_desktop");
    this.bonusgameBgSpineContainer = this.view.getContainerByID("bonusgameBgSpineContainer");
  }

  // Overrided to initialize portrait elements
  protected initializePortraitElements(): void {
    super.initializePortraitElements();
    this.freegameBgPortraitrSpine = this.view.getSpineById("freegame_idle_portrait");
  }

  // Method to play free game idle spine animation
  protected playFreegameIdleSpine():void {
    var _a;
    this.freegameBgSpineContainer.visible = true;
    this.freegameBgSpine.visible = true;
    (_a = this.freegameBgSpine) === null || _a === void 0 ? void 0 : _a.setPause(false);
    this.freegameBgSpine.playAnim(SlotConstantsBehavior.FREEGAME_IDLE_SPINE, true);
    !ingenuity.deviceEnv.isDesktop && this.playFreegameIdlePortraitSpine();
  }

  // Overrided to play free game idle portrait spine animation
  protected playFreegameIdlePortraitSpine(): void {
    var _a, _b;
    this.freegameBgPortraitrSpine && (this.freegameBgPortraitrSpine.visible = true);
    (_b = this.freegameBgPortraitrSpine) === null || _b === void 0 ? void 0 : _b.setPause(false);
    (_a = this.freegameBgPortraitrSpine) === null || _a === void 0 ? void 0 : _a.playAnim(SlotConstantsBehavior.FREEGAME_IDLE_SPINE, true);
  }

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.HIDE_HOLD_AND_RESPIN_BACKGROUND, this.hideHoldAndRespinBg, this);
  }
  /**
   * overrided to add bonus background case
   */
  protected changeBackground(evt: IEvent): void {
    if (evt.data === gameConstants.HOLD_RESPIN_BG_SHOW) {
      this.hideAllBg();
      this.bonusgameBgSpine = this.view.getSpineById("bonusgame_idle_desktop");
      !ingenuity.deviceEnv.isDesktop && (this.bonusgameBgPortraitSpine = this.view.getSpineById("bonusgame_idle_portrait"));
      !ingenuity.deviceEnv.isDesktop && this.handleBonusSpineVisibility();
      this.showHoldAndRespinBg();
    } else {
      super.changeBackground(evt);
    }
  }

  /**
   * Handle bonus spine visibility
   */
  private handleBonusSpineVisibility(): void {
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.LANDSCAPE) {
      this.bonusgameBgSpine.alpha = 1;
      this.bonusgameBgPortraitSpine.alpha = 0;
    } else {
      this.bonusgameBgSpine.alpha = 0;
      this.bonusgameBgPortraitSpine.alpha = 1;
    }
  }

  /**
   * overrided to show bonus background with fade effect
   */
  protected showHoldAndRespinBg(): void {
    this.bonusGameBGContainer.visible = true;
    this.bonusGameBGContainer.alpha = 0;
    const apperBonusBG = ingenuity.currentGame.add.tween(this.bonusGameBGContainer);
    apperBonusBG.to({ alpha: 1 }, gameConstants.ONE_SECOND_DELAY, Linear.None, true);
    apperBonusBG.onComplete.add(() => {
      ingenuity.currentGame.tweens.remove(apperBonusBG);
    }, this);
    this.playBonusgameIdleSpine();
  }

  /**
   * overrided to show bonus background with fade effect
   */
  protected hideHoldAndRespinBg(): void {
    this.bonusGameBGContainer.visible = false;
  }

  /**
   * overrided to play bonus background spine
   */
  private playBonusgameIdleSpine() {
    this.bonusgameBgSpine.visible = true;
    this.bonusGameBGContainer.addChild(this.bonusgameBgSpineContainer);
    this.bonusgameBgSpine.playAnim(gameConstants.BONUSGAME_SPINE, true);
    if (!ingenuity.deviceEnv.isDesktop) {
      this.playBonusgameIdleSpinePortrait();
    }
  }

  /**
   * Add to play bonus portrait spine
   */
  private playBonusgameIdleSpinePortrait() {
    this.bonusgameBgPortraitSpine.visible = true;
    this.bonusgameBgPortraitSpine.playAnim(gameConstants.BONUSGAME_SPINE, true);
  }
}
